import { Directive, HostListener, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NavigationItem } from '@stylehaven/components';

@Directive({
    standalone: false, selector: '[arrowNavigation]' })
export class ArrowNavigationDirective {
    constructor(
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute
    ) {}

    @Input() arrowNavigation: NavigationItem[];

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent): void {
        if (
            ['ArrowLeft', 'ArrowRight'].includes(event.key) &&
            this.arrowNavigation?.length > 0 &&
            (event.target as Element)?.tagName === 'BODY'
        ) {
            let nav: NavigationItem | undefined;
            if (this.arrowNavigation.length === 1) {
                nav = this.arrowNavigation[0];
                // bit hacky, but looks like the only way for now
                nav =
                    (event.key === 'ArrowLeft' && nav.icon?.includes('left')) ||
                    (event.key === 'ArrowRight' && nav.icon?.includes('right'))
                        ? nav
                        : undefined;
            } else {
                nav = event.key === 'ArrowLeft' ? this.arrowNavigation[0] : this.arrowNavigation[1];
            }

            if (nav) {
                this.router.navigate([nav.navigationLink.route], {
                    ...nav.navigationLink.extras,
                    relativeTo: this.activatedRoute
                });
            }
        }
    }
}
